module.exports = __webpack_public_path__ + "static/media/wuxia.155cc473.png";